import {Point, Binding} from 'gojs';

export const bindLocation = () => new Binding(
    'location',
    'loc',
    Point.parse,
).makeTwoWay(
    Point.stringify,
);

